module.exports = __webpack_public_path__ + "img/apple-brown-betty.96d4e6c6.jpg";